import React, { HTMLAttributes } from 'react'
import { ProductCardVariants, productCard } from './ProductCard.css'
import { AppLink } from '@otomoro/components/shared/AppLink'
import { resolveHref } from '@otomoro/sanity/lib/sanity.links'
import { AppText } from '@otomoro/components/shared/AppText'

interface ProductCardProps extends HTMLAttributes<Element>, ProductCardVariants {
	formula: string
	productName: string
	productLogo: any
	slug: string
	type: string
}

export const ProductCard: React.FC<ProductCardProps> = ({
	type,
	formula,
	productName,
	productLogo,
	slug,
}) => {
	const { base, logo, informationsContainer, linkExpand } = productCard()

	return (
		<div className={base()}>
			<span className={logo()} dangerouslySetInnerHTML={{ __html: productLogo.svg }} />
			<div className={informationsContainer()}>
				<AppLink
					textProps={{
						className: '!text-h3-mobile md:!text-h2',
						textTransform: 'uppercase',
						weight: 'bold',
						family: 'condensed',
						color: 'white',
					}}
					href={resolveHref(type, slug)}
					className={linkExpand()}
				>
					{formula}
				</AppLink>
				<AppText as="p" className="text-white mt-[0.3rem]" size="base" textTransform="uppercase">
					{productName}
				</AppText>
			</div>
		</div>
	)
}
